module.exports = __webpack_public_path__ + "static/media/icon-com-agenda.2e36cd06.svg";